import posthog from "posthog-js";

const DEFAULT_POSTHOG_HOST = "https://us.i.posthog.com";
const POSTHOG_DEFAULTS = "2026-01-30";
const WEBSITE_LOGS_SERVICE_NAME = "proxi-web";
const SESSION_RECORDING_BLOCK_SELECTOR = ".ph-no-capture";

let isInitialized = false;

export function initPostHog() {
	if (typeof window === "undefined" || isInitialized) {
		return;
	}

	const apiKey = import.meta.env.VITE_POSTHOG_API_KEY;
	if (!apiKey) {
		return;
	}

	posthog.init(apiKey, {
		api_host: import.meta.env.VITE_POSTHOG_HOST ?? DEFAULT_POSTHOG_HOST,
		autocapture: true,
		capture_dead_clicks: true,
		capture_exceptions: true,
		capture_pageview: "history_change",
		capture_pageleave: "if_capture_pageview",
		defaults: POSTHOG_DEFAULTS,
		disable_session_recording: false,
		enable_heatmaps: true,
		enable_recording_console_log: true,
		logs: {
			captureConsoleLogs: true,
			serviceName: WEBSITE_LOGS_SERVICE_NAME,
		},
		persistence: "localStorage+cookie",
		person_profiles: "identified_only",
		rageclick: true,
		session_recording: {
			blockSelector: SESSION_RECORDING_BLOCK_SELECTOR,
			maskAllInputs: true,
		},
	});

	isInitialized = true;
}

export { posthog };
